import { render, staticRenderFns } from "./GrantsConstraintsPlansSlidesDetails.vue?vue&type=template&id=46fbb60b&"
import script from "./GrantsConstraintsPlansSlidesDetails.vue?vue&type=script&lang=js&"
export * from "./GrantsConstraintsPlansSlidesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports